import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import AboutSec from "../../components/about/about";
import { useEffect } from "react";
import { customScript } from "../../common/customscript";
import SearchModel from "../../components/search_model/search";

const About = () => {
    useEffect(() => {
        customScript()
    },[])

    return (
        <>
            <Header />
            <AboutSec/>
            <Footer />
            <SearchModel/>
        </>
    )
}

export default About